export const SCOREKEEPER_BRAND_ASSETS = {
  icon32: '/brand/icons/app-icon-blue-32.png',
  icon64: '/brand/icons/app-icon-blue-64.png',
  icon180: '/brand/icons/app-icon-blue-180.png',
  icon192: '/brand/icons/app-icon-blue-192.png',
  icon512: '/brand/icons/app-icon-blue-512.png',
  iconDark512: '/brand/icons/app-icon-dark-512.png',
  logoHorizontalLight: '/brand/logos/logo-horizontal-light.png',
  logoHorizontalDark: '/brand/logos/logo-horizontal-dark.png',
  logoPrimaryLight: '/brand/logos/logo-primary-light.png',
  logoPrimaryDark: '/brand/logos/logo-primary-dark.png',
  logoRotatedLight: '/brand/logos/logo-rotated-the-light.png',
  logoRotatedDark: '/brand/logos/logo-rotated-the-dark.png',
  ogImage: '/brand/og-scorekeeper.png',
} as const;
